import {
    Component, ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ALIAS_VALIDATOR_MESSAGE, aliasValidator} from '../../../../../Validators/alias-validator';
import { MatrixService } from '../matrix.service';
import { MatrixExportDefinition } from '../../../../../Models/MatrixViewModel';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { ColourPickerComponent } from '../../../../../Common/colour-picker/colour-picker.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'aw-matrix-field-edit-form',
    templateUrl: './matrix-field-edit-form.component.html',
    styleUrls: ['../matrix-form.less', './matrix-field-edit-form.component.less'],
    imports: [MatCard, MatCardTitle, FormsModule, ReactiveFormsModule, ColourPickerComponent, MatCheckbox, MatButton]
})
export class MatrixFieldEditFormComponent implements OnInit, OnChanges {
    @Input() currentModel;
    @Input() useScoreAndColour: boolean;
    @Input() isSeverityMatrix: boolean;
    @Input() allData: MatrixExportDefinition;
    @Output() saved: EventEmitter<any> = new EventEmitter<any>();
    @Output() cancelled: EventEmitter<void> = new EventEmitter<void>();
	@ViewChild('firstInput', { static: true }) firstInput: ElementRef;
    config: UntypedFormGroup;
    colour: string = undefined;
    invalidFormatMessage: string = ALIAS_VALIDATOR_MESSAGE;

    constructor(private matrixService: MatrixService) {

    }

    ngOnInit() {
        this.focusOnFirstElement();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentModel) {
            this.config = new UntypedFormGroup({
                alias: new UntypedFormControl(this.currentModel.Alias, [Validators.required, aliasValidator]),
                description: new UntypedFormControl(this.currentModel.description, [Validators.required]),
                colour: this.useScoreAndColour ? new UntypedFormControl(this.currentModel.Colour, [Validators.required]) : new UntypedFormControl(null),
                score: this.useScoreAndColour ? new UntypedFormControl(this.currentModel.Score, [Validators.pattern("^[0-9]*$")]) : new UntypedFormControl(null),
                includedInQuery: this.useScoreAndColour ? new UntypedFormControl(this.currentModel.IncludedInQuery) : new UntypedFormControl(null),
            });
            this.focusOnFirstElement();
        }
    }

    cancel() {
        this.cancelled.emit();
    }

    saveField() {
        let result = this.config.getRawValue();
        if (!this.config.valid) {
            return;
        }
        let errors = this.matrixService.validateData(this.allData);
        if (errors) {
            for (let invalidDataKey in errors.invalidData) {
                if (errors.invalidData.hasOwnProperty(invalidDataKey)) {
                    let field = errors.invalidData[invalidDataKey];
                    if (field.field === 'Alias' && field.value === result.alias) {
                        return false;
                    }
                }
            }
        }

        this.currentModel.description = result.description;
        this.currentModel.Colour = result.colour;
        this.currentModel.Alias = result.alias;
        this.currentModel.Score = result.score;
        this.currentModel.IncludedInQuery = result.includedInQuery;
        this.saved.emit(this.currentModel);
    }
    
    private focusOnFirstElement() {
        this.firstInput.nativeElement.focus();
    }
}
